var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rc-container rc-background-back",attrs:{"cmpt":"AdminRegisterNew"}},[(_vm.isReady)?_c('DetailsRow',{attrs:{"companyId":_vm.companyId,"isAdmin":true},on:{"companySaved":_vm.companySaved}}):_vm._e(),_c('SpacerRow')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }